<template>
  <div id="app">
    <div class="promo">
      <img src="imgs/head.jpg" class="landing" />
      <div class="btn-down">
        <a href="#viewer"><i class="fa-solid fa-angle-down"></i></a>
      </div>
    </div>
    <router-view id="viewer" />
    <footer class="bg-tpbs-1 mt-5">
      <div class="container p-3 pb-4">
        <div class="row">
          <div class="col-9">
            <h5 class="mt-0 mt-md-3 text-light text-start">
              ©2022 องค์การกระจายเสียงและแพร่ภาพสาธารณะแห่งประเทศไทย
            </h5>
          </div>
          <div class="col-3 text-end">
            <a href="https://www.thaipbs.or.th" target="_blank"
              ><img src="imgs/logo.png" class="h-footer"
            /></a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  name: "App",
};
</script>

<style>
@import "/css/font.css";
@import "/css/color.css";
@import "/css/modal.css";
@import "/css/app.css";
@import "/css/custom.css";
</style>
